import UnidadeMedida from './UnidadeMedida';

export default UnidadeMedida;